const msToReadingTime = ms => {
    const min = Math.floor(ms / 60000)
    if (min === 0)
        return '< 1 min read';

    return min + ' min read'
}

export { msToReadingTime }
